const DAYS: { key: string; label: string }[] = [
  { key: "mon", label: "Lundi" },
  { key: "tue", label: "Mardi" },
  { key: "wed", label: "Mercredi" },
  { key: "thu", label: "Jeudi" },
  { key: "fri", label: "Vendredi" },
  { key: "sat", label: "Samedi" },
  { key: "sun", label: "Dimanche" },
];

export function OpeningHours({
  hours,
  className,
}: {
  hours: Record<string, [string, string][]>;
  className?: string;
}) {
  return (
    <dl className={className}>
      {DAYS.map(({ key, label }) => {
        const ranges = hours[key] ?? [];
        return (
          <div key={key} className="flex justify-between gap-4 py-0.5">
            <dt className="font-semibold">{label}</dt>
            <dd>
              {ranges.length === 0
                ? "Fermé"
                : ranges.map((r, i) => (
                    <span key={i}>
                      {r[0]}–{r[1]}
                      {i < ranges.length - 1 ? " · " : ""}
                    </span>
                  ))}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
